import styled from 'styled-components';
import { Empty } from 'antd';

export const NoDataComponent = styled(Empty)`
  margin: 20px;
  width: ${({ width }) => width && width};
  .ant-empty-description {
    color: lightgrey;
    font-family: var(--appPrimaryFont);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.02em;
  }
`;
